import React from 'react';
import { Card, Col, Row, Space, Tag, Typography } from 'antd';
import { formatMoney } from '@/utils/format';

const { Text, Title } = Typography;

export interface EpcEstimateCommercialHeroProps {
  currency?: string;
  revisionLabel?: string;
  tec?: number | null;
  finalBid?: number | null;
  marginPct?: number | null;
  costModel?: string | null;
  pricing?: string | null;
  boqCoveragePct?: number | null;
}

export const EpcEstimateCommercialHero: React.FC<EpcEstimateCommercialHeroProps> = ({
  currency,
  revisionLabel,
  tec,
  finalBid,
  marginPct,
  costModel,
  pricing,
  boqCoveragePct,
}) => (
  <Card size="small" style={{ marginBottom: 12 }}>
    <Row gutter={[16, 8]} align="middle">
      <Col flex="auto">
        <Space wrap size="large">
          <div>
            <Text type="secondary">Revision</Text>
            <div>
              <Title level={5} style={{ margin: 0 }}>
                {revisionLabel || '—'}
              </Title>
            </div>
          </div>
          <div>
            <Text type="secondary">TEC</Text>
            <div>
              <Text strong>
                {tec != null
                  ? formatMoney(tec, { display: 'plain', maximumFractionDigits: 0 })
                  : '—'}
                {currency ? ` ${currency}` : ''}
              </Text>
            </div>
          </div>
          <div>
            <Text type="secondary">Final bid</Text>
            <div>
              <Text strong>
                {finalBid != null
                  ? formatMoney(finalBid, { display: 'plain', maximumFractionDigits: 0 })
                  : '—'}
              </Text>
            </div>
          </div>
          <div>
            <Text type="secondary">Margin</Text>
            <div>
              <Text strong>{marginPct != null ? `${marginPct}%` : '—'}</Text>
            </div>
          </div>
        </Space>
      </Col>
      <Col>
        <Space wrap>
          {costModel ? <Tag color={costModel === 'READY' ? 'green' : 'default'}>Cost {costModel}</Tag> : null}
          {pricing ? <Tag color={pricing.includes('READY') ? 'green' : 'default'}>Pricing {pricing}</Tag> : null}
          {boqCoveragePct != null ? (
            <Tag color={boqCoveragePct >= 90 ? 'green' : 'orange'}>BOQ {boqCoveragePct}%</Tag>
          ) : null}
        </Space>
      </Col>
    </Row>
  </Card>
);
